import NavigationTab from './NavigationTab'

export default NavigationTab
